export class WorkerDto{
    workerId:number
    workerCode: string
    workerName: string
    aadharCardNumber: string
    dateOfBirth: any;
    address: string;
    contractorId: number;
    dateOfJoining: any;
    villageFrom: string;
    isActive?: boolean;
    createdAt?: Date;
    createdUser?: string;
    updatedAt?: Date;
    updatedUser?: string;
    versionFlag?: number;
    contractorName?: string;
    villageFromId?:number


   
    constructor(
        workerId:number,
        workerCode: string,
        workerName: string,
        aadharCardNumber: string,
        dateOfBirth: any,
        address: string,
        contractorId: number,
        dateOfJoining: any,
        villageFrom: string,
        isActive?: boolean,
        createdAt?: Date,
        createdUser?: string,
        updatedAt?: Date,
        updatedUser?: string,
        versionFlag?: number,
        contractorName?: string,
        villageFromId?:number

      
    ){

        this.workerId = workerId
        this.workerCode = workerCode
        this.workerName = workerName
        this.aadharCardNumber = aadharCardNumber
        this.dateOfBirth = dateOfBirth
        this.address = address
        this.contractorId = contractorId
        this.dateOfJoining = dateOfJoining
        this.villageFrom = villageFrom
        this.isActive = isActive
        this.createdAt = createdAt
        this.createdUser = createdUser
        this.updatedAt = updatedAt
        this.updatedUser = updatedUser
        this.versionFlag = versionFlag
        this.contractorName = contractorName
        this.villageFromId=villageFromId



       
    }
}


